module.exports = "/assets/data/244f5628e6b9c547e2e35ff7f6f86c70-BN24.data.json";